import uuid from 'uuid/v1';

import get from 'lodash/get';
import format from 'date-fns/format';

export default function (fields = {}, props = {}) {
  const searchParams = {
    adults: fields.adults,
  };

  if (fields.dates) {
    searchParams.start_date = format(fields.dates.startDate, 'dd.MM.yyyy');
  }

  if (fields.nights) {
    searchParams.nights = fields.nights;
  }

  if (fields.departure) {
    searchParams.from_city = fields.departure;
  }

  const { destinationData, destinationQuery } = props;
  if (destinationData) {
    searchParams.destination_query = destinationQuery || destinationData.name;

    switch (destinationData.type) {
      case 'geo':
        searchParams.to_city = destinationData.id;
        searchParams.to_country = destinationData.countryId;
        break;
      case 'tourism':
        searchParams.to_region = destinationData.id;
        searchParams.to_country = destinationData.countryId;
        break;
      case 'country':
        searchParams.to_country = destinationData.id;
        break;
      case 'hotel':
        searchParams.to_city = destinationData.cityId;
        searchParams.to_country = destinationData.countryId;
        break;
      default:
        break;
    }
  }

  searchParams.kids = get(fields, 'childrenAges.length') || undefined;
  searchParams.kids_ages = get(fields, 'childrenAges', []).join(',') || undefined;

  searchParams.flex_nights = fields.flexNights ? 2 : undefined;

  searchParams.search_id = uuid();

  return searchParams;
}
